import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterContentChecked, ChangeDetectorRef, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SummaryHeaderService } from 'src/app/core/services/summary-header.service';

@Component({
	selector: 'ahp-profiles-layout',
	templateUrl: './profiles-layout.component.html',
	styleUrls: ['./profiles-layout.component.scss'],
	animations: [
		trigger('sideNavSlide', [
			state(
				'show',
				style({
					left: 0,
				})
			),
			state(
				'hide',
				style({
					left: -256,
				})
			),
			transition('* => *', animate('200ms ease-out')),
		]),
	],
})
export class ProfilesLayoutComponent implements AfterContentChecked {
	/**
	 * Determines if we are showing the summary header.
	 */
	public showHeader = true;
	/**
	 * Flag for whether mobile navigation is shown
	 */
	public mobileNavEnabled = false;
	/**
	 * The page's heading for accessibility
	 */
	public pageHeading: string;
	/**
	 * Our constructor
	 * @param _headerService service for showing / hiding the summary header
	 * @param _cdr The change detection object for the component.
	 * @param _title The title service
	 */
	constructor(private _headerService: SummaryHeaderService, private _cdr: ChangeDetectorRef, private _title: Title) {}

	ngAfterContentChecked(): void {
		this.pageHeading = this._title.getTitle();
		this._headerService.showHeader.subscribe((resp) => {
			this.showHeader = resp;
		});
		this._cdr.detectChanges();
	}

	/**
	 * Toggles navigation for the collapsed menu on mobile.
	 */
	toggleMobileNav(): void {
		this.mobileNavEnabled = !this.mobileNavEnabled;
	}

	/**
	 * Returns if the sidenav should be shown or hidden by animation
	 */
	get sideNavShow() {
		return this.mobileNavEnabled ? 'show' : 'hide';
	}
}
